import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Spacer } from "@/components/layout";
import { Avatar, Button, Menu, Search, Tooltip } from "@/components/ui";
import { useSession } from "@/auth/useSession";
import { NotificationsMenu } from "./NotificationsMenu";
import styles from "./shell.module.css";

export interface TopNavProps {
  onToggleSidebar?: () => void;
}

export function TopNav({ onToggleSidebar }: TopNavProps) {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const { user, signOut } = useSession();
  const displayName =
    (user?.user_metadata?.display_name as string | undefined) ??
    user?.email ??
    "HQ Employee";

  return (
    <header className={styles.topNav}>
      {onToggleSidebar ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          Menu
        </Button>
      ) : null}
      <div style={{ flex: "1 1 320px", maxWidth: 420 }}>
        <Search
          value={query}
          onValueChange={setQuery}
          placeholder="Search Users"
          label="Search Users"
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              const q = query.trim();
              void navigate(q ? `/app/users?q=${encodeURIComponent(q)}` : "/app/users");
            }
          }}
        />
      </div>
      <Tooltip content="Command Palette expands in later K waves">
        <Button variant="secondary" size="sm" disabled>
          Command
        </Button>
      </Tooltip>
      <Spacer />
      <Flex gap={8} align="center">
        <NotificationsMenu />
        <Button variant="ghost" size="sm" disabled>
          Help
        </Button>
        <Menu
          label="Profile"
          items={[
            {
              id: "users",
              label: "Users directory",
              onSelect: () => {
                void navigate("/app/users");
              },
            },
            {
              id: "signout",
              label: "Sign out",
              onSelect: () => {
                void (async () => {
                  await signOut();
                  void navigate("/auth/sign-in");
                })();
              },
            },
          ]}
        />
        <Avatar name={displayName} />
      </Flex>
    </header>
  );
}
